document.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('[data-quantity-wrapper]');
    const removeBtns = document.querySelectorAll('[data-remove-key]');
  
    // Filas de controle para evitar condições de corrida
    let updateQueue = {};
    let requestQueue = Promise.resolve();
  
    // Helper simples de formatação
    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, Shopify.money_format || 'R$ {{amount}}');
      }
      const value = (cents / 100).toFixed(2).replace('.', ',');
      return `R$ ${value}`;
    }
  
    // Bloqueio de Checkout
    function setCheckoutLoading(isLoading) {
      const checkoutBtns = document.querySelectorAll('button[name="checkout"], input[name="checkout"], .cart-summary__checkout');
      checkoutBtns.forEach(btn => {
         if (isLoading) {
           btn.setAttribute('disabled', 'disabled');
           btn.classList.add('is-loading');
           btn.style.opacity = '0.6';
           btn.style.pointerEvents = 'none';
           if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
           btn.textContent = 'Processando...';
         } else {
           btn.removeAttribute('disabled');
           btn.classList.remove('is-loading');
           btn.style.opacity = '';
           btn.style.pointerEvents = '';
           if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
         }
      });
    }
  
    // Atualização Otimista e Debounced
    function changeLineQuantity(key, newQty, itemEl) {
      if (!key) return;
  
      // Cancela timeout anterior
      if (updateQueue[key] && updateQueue[key].timeout) {
        clearTimeout(updateQueue[key].timeout);
      }
  
      // --- Optimistic UI Updates ---
      if (itemEl) {
        // 1. Atualiza Input
        const input = itemEl.querySelector('.quantity-input__field');
        if (input) input.value = newQty;
  
        // 2. Atualiza Botões
        const btnMinus = itemEl.querySelector('[data-qty-minus]');
        if (btnMinus) {
          btnMinus.disabled = newQty <= 1;
          btnMinus.classList.toggle('quantity-input__btn--disabled', newQty <= 1);
        }
  
        // 3. Feedback visual de remoção ou opacidade
        if (newQty === 0) {
           itemEl.style.display = 'none'; // Remove visualmente
           itemEl.setAttribute('aria-hidden', 'true');
        } else {
           itemEl.style.opacity = '0.5'; // Feedback de carregando
        }
  
        // 4. Atualiza Subtotal (Estimativa Local)
      const unitPriceRaw = itemEl.querySelector('[data-unit-price]')?.dataset.unitPrice;
      const currentQty = parseInt(itemEl.querySelector('[data-quantity-wrapper]')?.querySelector('input')?.value || '0', 10); // A quantidade nova já está no input se for change, mas aqui newQty é o target.
      // Precisamos da quantidade ANTERIOR para calcular a diferença? 
      // Não, a gente sabe a newQty. Precisamos saber quanto TAVA antes?
      // Sim, diff = newQty - oldQty.
      // Mas o input já foi atualizado visualmente na linha 52. 
      // Vamos assumir que a diferença é baseada no valor que estava no DOM antes do update?
      // O DOM (input.value) já tem o newQty.
      // Melhor calcular: Subtotal = Subtotal - (Price * OldQty) + (Price * NewQty)
      // Mas não sabemos OldQty facilmente aqui sem ler antes.
      // Simplificação: Se for remoção (newQty=0), subtraímos (Price * CurrentQtyDisplayed).
      // Se for update, é mais chato sem o old value.
      // Vamos focar no caso de REMOÇÃO (newQty === 0) que é o mais crítico para feedback visual.
      
      if (newQty === 0 && unitPriceRaw) {
          const unitPrice = parseInt(unitPriceRaw, 10);
          // Tentamos pegar a quantidade que estava antes...
          // O input já pode ter sido atualizado ou não.
          // Se for clique no botão remover, o input ainda tem o valor antigo (provavelmente).
          // Vamos pegar do input se existir.
          const inputEl = itemEl.querySelector('.quantity-input__field');
          const qtyToRemove = inputEl ? parseInt(inputEl.value || '1', 10) : 1;
          
          const subtotalEl = document.querySelector('[data-cart-subtotal-raw]');
          if (subtotalEl) {
             let currentSubtotal = parseInt(subtotalEl.getAttribute('data-cart-subtotal-raw') || '0', 10);
             const amountToRemove = unitPrice * qtyToRemove;
             const newSubtotal = Math.max(0, currentSubtotal - amountToRemove);
             
             subtotalEl.textContent = formatMoney(newSubtotal);
             subtotalEl.setAttribute('data-cart-subtotal-raw', newSubtotal);
          }
      }
      }
  
      // Dispara update
      setCheckoutLoading(true);
      const updateToken = Date.now() + Math.random();
      
      updateQueue[key] = {
         token: updateToken,
         timeout: setTimeout(() => {
            performLineUpdate(key, newQty, itemEl, updateToken);
         }, 300) // 300ms debounce
      };
    }
  
    // Executa a requisição (Serializada)
    async function performLineUpdate(key, newQty, itemEl, token) {
      requestQueue = requestQueue.then(async () => {
        try {
          // Verifica se ainda é válido
          if (updateQueue[key] && updateQueue[key].token !== token) return;
  
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: newQty })
          });
  
          if (!res.ok) throw new Error('Erro na requisição');
  
          const cart = await res.json();
          
          // Se houver mais requisições na fila (ex: remoção em massa), 
          // não fazemos refresh pesado do DOM para evitar piscar/reaparecer.
          const hasPendingRequests = Object.keys(updateQueue).some(k => updateQueue[k].token !== token && updateQueue[k].timeout);
          
          if (!hasPendingRequests) {
            updateSummary(cart);
            // Se o item não foi removido, removemos a opacidade
            if (itemEl && newQty > 0) {
               itemEl.style.opacity = '';
               // Atualiza preços da linha se possível
               // Aqui precisaríamos de lógica para atualizar o preço total da linha
            }
            
            // Verifica se o item removido realmente sumiu
            if (newQty === 0 && itemEl) {
               const itemStillExists = cart.items.find(i => i.key === key);
               if (!itemStillExists) {
                  itemEl.remove();
                  checkEmptyCart();
               } else {
                  // Voltou? Restaura visualização
                  itemEl.style.display = '';
                  itemEl.setAttribute('aria-hidden', 'false');
                  // Mostra erro?
               }
            }
          }
  
        } catch (e) {
          console.error(e);
          // Reverte UI em caso de erro grave
          if (itemEl) {
             itemEl.style.display = '';
             itemEl.style.opacity = '';
          }
        } finally {
           if (updateQueue[key] && updateQueue[key].token === token) {
              delete updateQueue[key];
           }
        }
      }).finally(() => {
         // Se fila vazia, libera checkout
         if (Object.keys(updateQueue).length === 0) {
            setCheckoutLoading(false);
         }
      });
  
      return requestQueue;
    }
  
    function updateSummary(cart) {
      const subtotalEl = document.querySelector('[data-cart-subtotal]');
      const discountTotalEl = document.querySelector('[data-cart-discount-total]');
      const totalEl = document.querySelector('[data-cart-total]');
      const discountsWrapper = document.querySelector('[data-cart-discounts-wrapper]');
      const discountsEl = document.querySelector('[data-cart-discounts]');
  
      if (subtotalEl) {
         subtotalEl.textContent = formatMoney(cart.original_total_price);
         // Atualiza raw também
         subtotalEl.setAttribute('data-cart-subtotal-raw', cart.original_total_price);
      }
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  
      if (discountTotalEl) {
        const diff = cart.original_total_price - cart.total_price;
        discountTotalEl.textContent = diff > 0 ? `-${formatMoney(diff)}` : 'R$ 0,00';
      }
  
      if (discountsEl) {
        discountsEl.innerHTML = '';
        if (cart.cart_level_discount_applications?.length > 0) {
          cart.cart_level_discount_applications.forEach((discount) => {
            const div = document.createElement('div');
            div.className = 'cart-summary__discount';
            div.innerHTML = `<span>${discount.title}</span><span>-${formatMoney(discount.total_allocated_amount)}</span>`;
            discountsEl.appendChild(div);
          });
          if (discountsWrapper) discountsWrapper.style.display = '';
        } else if (discountsWrapper) {
          discountsWrapper.style.display = 'none';
        }
      }
    }
  
    function checkEmptyCart() {
       const container = document.querySelector('.cart-items');
       if (container && container.children.length === 0) {
          location.reload(); // Recarrega para mostrar estado vazio
       }
    }
  
    // --- Inicialização de Eventos ---
  
    // 1. Wrappers de Quantidade
    wrappers.forEach((wrapper) => {
      const input = wrapper.querySelector('.quantity-input__field');
      const minusBtn = wrapper.querySelector('[data-qty-minus]');
      const plusBtn = wrapper.querySelector('[data-qty-plus]');
      
      // Tenta pegar a key do artigo pai
      const cartItem = wrapper.closest('.cart-item');
      const key = cartItem ? cartItem.dataset.key : null;
      const max = parseInt(wrapper.dataset.max || '9999', 10);
      const min = parseInt(input.min || '1', 10);
  
      if (!key) return; // Sem key não podemos usar a nova lógica segura
  
      const handleUpdate = (newVal) => {
         let val = parseInt(newVal, 10);
         if (isNaN(val) || val < min) val = min;
         if (val > max) val = max;
         
         // Atualiza input visualmente logo
         input.value = val;
         changeLineQuantity(key, val, cartItem);
      };
  
      minusBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        handleUpdate(parseInt(input.value) - 1);
      });
  
      plusBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        handleUpdate(parseInt(input.value) + 1);
      });
  
      input.addEventListener('change', () => {
         handleUpdate(input.value);
      });
    });
  
    // 2. Botões de Remover
    removeBtns.forEach(btn => {
       btn.addEventListener('click', (e) => {
          e.preventDefault();
          const key = btn.dataset.removeKey;
          const cartItem = btn.closest('.cart-item');
          if (key) {
             changeLineQuantity(key, 0, cartItem);
          }
       });
    });
  });
